import axios from "axios";

const APIURL =
  window.location.hostname === "localhost" ||
  window.location.hostname === "nzen"
    ? "http://newnextjs.web/api/report"
    : "https://apilx.optigoapps.com/api/report";

// const APIURL = "https://api.optigoapps.com/ReactStore/ReactStore.aspx";
// const APIURL = "https://livenx.optigoapps.com/api/report";
// const APIURL = "http://nzen/jo/ExpressApp/EvoApp.aspx";

export const CommonAPI = async (body) => {
  const device_token = sessionStorage.getItem("device_token");
  const SV = sessionStorage.getItem("SV");

  const finalSv =
    window.location.hostname === "localhost" ||
    window.location.hostname === "nzen"
      ? "0"
      : SV || "";

  const header = {
    Authorization: `Bearer ${device_token}`,
    version: "v1",
    sv: `${finalSv}`,
    sp: 93,
  };

  try {
    const response = await axios.post(APIURL, body, { headers: header });
    return response?.data;
  } catch (error) {
    console.error("error is..", error);
  }
};
